export const sortByData = [
    { id: 'dateModified', name: 'Date Modified' },
    { id: 'likeCount', name: 'Rating' }
];
